enum Types {
    Job,
    Management,
    Ergonomic,
};

export default Types;